<template>
  <div class="footer">
    <div class="footer-links row justify-center">
      <router-link v-for="(link, linkIndex) in links"
                   :key="`footer-link-${linkIndex}`"
                   :to="link.to"
                   class="footer-link">
        <div :class="['arrow-wrap', `arrow--${link.color}`]">
          <div class="arrow">
            <div class="arrow-tail"></div>
            <div class="arrow-tip"></div>
          </div>
        </div>
        <div class="footer-link__title">
          {{link.title}}
        </div>
      </router-link>
    </div>
    <div class="footnote--wrap row justify-center">
      <div class="footnote"
           v-html="$t('global.footnote')">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      links: [
        {
          title: 'Corporate websites',
          to: '/contact',
          color: 'red',
        },
        {
          title: 'E-commerce',
          to: '/contact',
          color: 'blue',
        },
        {
          title: 'Web apps',
          to: '/contact',
          color: 'green',
        },
        {
          title: 'Landing pages',
          to: '/contact',
          color: 'orange',
        },
      ],
    };
  },
};
</script>

<style scoped lang="stylus">
@import '../styles/variables';

.footnote--wrap {
  position: relative;
  z-index: 610;
}

.footnote {
  font-size: 12px;
  font-weight: 300;
  width: 100%;
  text-align: center;
  line-height: 31px;
  margin-bottom: 60px;
  margin-top: 25px;
}

.footer-links {
  max-width: 230px;
  margin: 0 auto;
  margin-top: 70px;
  position: relative;
  z-index: 610;
}

.footer-link {
  margin-bottom: 40px;
  width: 100%;
  padding-left: 60px;
  position: relative;
}

.footer-link__title {
  transition: transform 0.1s cubic-bezier(0.47, 0, 0.75, 0.72);
}

.arrow-wrap {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  margin-bottom: 25px;
  overflow: hidden;
  max-width: 60px;
  height: 10px;
  transition: padding-left 0.1s cubic-bezier(0.47, 0, 0.75, 0.72);

  .arrow {
    width: 60px;
    display: flex;
    align-items: center;
    transform: translateZ(0) translateX(0);
  }

  .arrow-tail {
    width: 30px;
    height: 2px;
    transform-origin: right;
  }

  .arrow-tip {
    width: 9px;
    height: 0;
    border-style: solid;
    border-width: 4.5px 0 4.5px 7.8px;
  }
}

.footer-link {
  &:hover {
    .arrow-wrap {
      padding-left: 20px;

      .arrow {
        animation-name: arrowToRight, arrowFromLeft;
        animation-duration: 0.1s, 0.2s;
        animation-timing-function: cubic-bezier(0.35, 0.88, 0.71, 1), cubic-bezier(0.24, 0.85, 0.75, 1);
        animation-delay: 0.1s, 0.3s;
        animation-iteration-count: 1, 1;
        animation-direction: normal, normal;
        animation-fill-mode: forwards, forwards;
      }

      .arrow-tail {
        animation-name: arrowTailFromLeft;
        animation-duration: 0.4s;
        animation-timing-function: cubic-bezier(0, 0.57, 0.46, 1.04);
        animation-delay: 0.35s;
        animation-iteration-count: 1;
        animation-direction: normal;
        animation-fill-mode: forwards;
      }
    }

    .footer-link__title {
      transform: translateX(20px);
    }
  }
}

@media (min-width: $breakpoint-sm-min) {
  .footer-links {
    max-width: 450px;
    margin-top: 55px;
    justify-content: space-between;

    .footer-link {
      width: 47%;
      display: flex;
      align-items: center;
    }
  }

  .footnote {
    font-size: 15px;
    margin-bottom: 35px;
    margin-top: 0;
  }
}

@media (min-width: $breakpoint-md-min) {
  .footer {
    max-width: 1120px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .footer-link, .footnote {
    font-size: 14px;
    line-height: 31px;
  }

  .footnote {
    margin: 0;
  }

  .footer-link {
    margin-bottom: 35px;
  }

  .footer-links {
    margin-top: 35px;
    margin-left: 0;
  }
}

@media (min-width: $breakpoint-lg-min) {
  .footer {
    max-width: 1350px;
    padding-top: 45px;
    padding-bottom: 45px;
  }

  .footer-link, .footnote {
    font-size: 15px;
  }
}
</style>
